import { Button, Form, Col, Offcanvas, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import { EMAIL_REGEX } from "../../utility/constants";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: number
    uuid?: string
    name: string
    phone: string | number
    firm_name: string
    gst?: string
    email?: string
    status?: string
    created_by?: number
    created_at?: Date
    updated_at?: Date
}

const AddSuppliers = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        data.phone = Number(data.phone.toString().replaceAll("-", ""));

        const url = isEdit ? `supplier/update` : "supplier/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn",
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('name', '');
        setValue('phone', '' as any);
        setValue('firm_name', '');
        setValue('gst', '');
        setValue('email', '');
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Supplier" : "Add Supplier"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* Name */}
                                <Controller
                                    control={control}
                                    name="name"
                                    rules={{ required: "Please Enter Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Name</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.name}
                                            />
                                            {(errors["name"]?.message || Boolean(errors["name"]?.message) || (isTouched && !watchAllFields.name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.name?.message || "Please Enter Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* Phone */}
                                <Controller
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: "Please Enter Phone",
                                    }}
                                    render={({ field: { onChange }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Phone</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control ps-3 p-2"
                                                placeholder="Mobile"
                                                onChange={onChange}
                                                onKeyPress={HelperService.allowOnlyNumericValue}
                                                onKeyUp={(e) => HelperService.contactFormatter(e)}
                                                value={watchAllFields.phone}
                                            />
                                            {(errors["phone"]?.message ||
                                                Boolean(errors["phone"]?.message) ||
                                                (isTouched && !watchAllFields.phone)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.phone?.message || "Please Enter Phone."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {/* Firm Name */}
                                <Controller
                                    control={control}
                                    name="firm_name"
                                    rules={{
                                        required: "Please Enter Firm Name",
                                    }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Firm Name</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Firm Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.firm_name}
                                            />
                                            {(errors["firm_name"]?.message || Boolean(errors["firm_name"]?.message) || (isTouched && !watchAllFields.firm_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.firm_name?.message || "Please Enter Firm Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* GST */}
                                <Controller
                                    control={control}
                                    name="gst"
                                    rules={{
                                        required: false,
                                    }}
                                    render={({ field: { onChange, onBlur } }) => (
                                        <div className="mb-2">
                                            <Form.Label>GST</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="GST"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.gst}
                                            />
                                        </div>
                                    )}
                                />

                                {/* Firm Name */}
                                <Controller
                                    control={control}
                                    name="email"
                                    rules={{
                                        required: false,
                                        pattern: {
                                            value: EMAIL_REGEX,
                                            message: "Please Enter Valid Email.",
                                        },
                                    }}
                                    render={({ field: { onChange, onBlur } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Email</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Email"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.email}
                                            />
                                            {(errors["email"]?.message || Boolean(errors["email"]?.message)) && (
                                                <div className="login-error">
                                                    <Label title={errors.email?.message || "Please Enter Email."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddSuppliers;
